function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.332a6.674 6.674 0 00-6.667 6.667c0 3.224 2.3 5.92 5.346 6.534-.04-.335.024-.678.186-.982a5.676 5.676 0 01-4.532-5.552A5.673 5.673 0 018 2.332a5.673 5.673 0 015.666 5.667 5.64 5.64 0 01-.232 1.595l.659 1.098A6.616 6.616 0 0014.666 8 6.674 6.674 0 008 1.332zm.159 2.66a.5.5 0 00-.493.507v3.5H5.5a.5.5 0 100 1h2.666a.5.5 0 00.5-.5v-4a.5.5 0 00-.507-.507zm3.174 4.34a1 1 0 00-.857.486l-3 5a1 1 0 00.857 1.514h6a1 1 0 00.857-1.514l-3-5a1 1 0 00-.857-.486zm0 1.333c.184 0 .333.15.333.334v2.666a.333.333 0 01-.666 0V10c0-.184.149-.334.333-.334zm0 3.917a.417.417 0 110 .834.417.417 0 010-.834z"
});

function SvgSlaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSlaIcon;